import React from 'react';
import ConductLedger from './ConductLedger';

/** Principal-side 360° Teacher Profile & Appraisal Record modal. */
export default function TeacherRecordView({ teacher, user, attendanceStatus, onClose }) {
  if (!teacher) return null;
  const color = { present: '#4caf50', absent: '#f44336', late: '#ff9800' }[attendanceStatus] || '#666';
  const row = (k, v) => <div style={{ marginBottom: 10 }}><strong>{k}:</strong> {v}</div>;
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'flex-start', overflowY: 'auto', padding: 10 }}>
      <div style={{ background: '#fff', padding: 20, width: '100%', maxWidth: 760, borderRadius: 15, boxShadow: '0 10px 30px rgba(0,0,0,0.3)' }}>
        <h3 style={{ marginBottom: 16, color: '#333', textAlign: 'center' }}>👨‍🏫 Teacher 360° Profile &amp; Appraisal Record</h3>
        {row('Name', teacher.name || 'N/A')}
        {row('Email', teacher.email || 'N/A')}
        {row('Assigned Class', teacher.class || 'Unassigned')}
        {row('Section', teacher.section || 'No Section')}
        {row('Today\'s Attendance', <span style={{ color, fontWeight: 'bold' }}>{attendanceStatus ? attendanceStatus.toUpperCase() : 'NOT MARKED'}</span>)}
        {row('Account Created', teacher.createdAt ? new Date(teacher.createdAt).toLocaleDateString() : 'N/A')}
        <ConductLedger viewer={user} teacherId={teacher._id} canAppreciate />
        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <button onClick={onClose} style={{ padding: '10px 20px', background: '#dc3545', color: '#fff', border: 'none', borderRadius: 5, cursor: 'pointer', fontWeight: 'bold' }}>❌ Close</button>
        </div>
      </div>
    </div>
  );
}
